/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Save/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Save({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/CompleteTreatment/Content/Actions/Save",
  onSubmit,
  isSubmitting
  
}) {
let completeTreatmentSubmitData = fromData.useDataSubmit({ viewPath,
context: 'complete_treatment',
})
let completeTreatmentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'complete_treatment',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginLeft={dtSpaceXs}
 data="complete_treatment"
 onClick={completeTreatmentSubmitData}
 disabled={completeTreatmentIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Apply"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}